import PropTypes from 'prop-types';
import React from 'react';
import { Modal, SanitizedRender, UserStore } from '@reverbdotcom/discovery-ui';

import User from '../user';
import NewBrandRequestForm from './new_brand_request_form';

class NewBrandRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      requestSuccessfullySubmitted: false,
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRequestSuccess = this.handleRequestSuccess.bind(this);
  }

  handleCloseModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  handleClick(e) {
    e.preventDefault();
    if (UserStore.getState().loggedOut) {
      User.showInlineRegistrationOrLogin(e, e.currentTarget);
    } else {
      this.setState({
        isModalOpen: true,
      });
    }
  }

  handleRequestSuccess() {
    this.setState({
      requestSuccessfullySubmitted: true,
    });
  }

  renderForm() {
    return (
      <NewBrandRequestForm
        newBrand={this.props.newBrand}
        handleRequestSuccess={this.handleRequestSuccess}
        requestSuccessfullySubmitted={this.state.requestSuccessfullySubmitted}
      />
    );
  }

  renderNewBrandModal() {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        onRequestClose={this.handleCloseModal}
      >
        <div className="dialog medium-dialog">
          {this.renderForm()}
        </div>
      </Modal>
    );
  }

  render() {
    return (
      <section>
        <div className="alert alert-warning mt-1">
          <h4 className="heading-4">
            <i className="fa fa-exclamation-triangle" />
            &nbsp;
            {I18n.t('listingForm.newBrandRequest.dontRecognize')}
          </h4>
          <p className="size-90 mb-0">
            {I18n.t('listingForm.newBrandRequest.couldBeDifficult')}
          </p>
          <p
            className="size-90 scaling-mt-1 mb-0"
            onClick={this.handleClick}
            data-registration-message={
              I18n.t('listingForm.newBrandRequest.registrationWallMessage')
            }
            data-registration-url-source="new_brand"
          >
            <SanitizedRender
              html={
                I18n.t('listingForm.newBrandRequest.pleaseSubmitHtml', {
                  linkOpen: '<a>',
                  linkClose: '</a>',
                })
              }
            />
          </p>
          {this.renderNewBrandModal()}
        </div>
      </section>
    );
  }
}

NewBrandRequest.propTypes = {
  newBrand: PropTypes.string,
};

export default NewBrandRequest;
